export default "__VITE_ASSET__DiRoXo$x__"